import { alpha, Theme } from '@mui/material';

export default {
    toastItem: {
        backgroundColor: (theme: Theme) => theme.palette.background.default,
        borderLeft: `2px solid`,
        boxShadow: (theme: Theme) => `0px 2px 8px 0px ${alpha(theme.palette.text.primary, 0.2)}`,
        borderRadius: '2px',
        minWidth: '280px',
        maxWidth: '350px',
        p: 1.5,
        pl: 1.25,
        alignItems: 'flex-start',
        position: 'relative',

        '&.toast-item--type-success': {
            borderLeftColor: (theme: Theme) => theme.palette.success.main,
            '& .toast-item__icon': {
                color: (theme: Theme) => theme.palette.success.main,
            },
        },
        '&.toast-item--type-error': {
            borderLeftColor: (theme: Theme) => theme.palette.error.main,
            '& .toast-item__icon': {
                color: (theme: Theme) => theme.palette.error.main,
            },
        },
        '&.toast-item--type-info': {
            borderLeftColor: (theme: Theme) => theme.palette.primary.main,
            '& .toast-item__icon': {
                color: (theme: Theme) => theme.palette.primary.main,
            },
        },
    },
    toastItemIcon: {
        pr: 1,
        fontSize: '16px',
        display: 'inline-flex',
    },
    toastItemContent: {
        flexGrow: 1,
    },
    toastItemTitle: {
        fontWeight: '600',
        pr: '20px',
    },
    toastItemDesc: {
        pt: 0.5,
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
    },
    toastItemCloseBtn: {
        position: 'absolute',
        right: '8px',
        top: '8px',
        display: 'inline-flex',
        p: '4px',
        fontSize: '12px',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
        '&:hover': {
            color: (theme: Theme) => theme.palette.primary.main,
            cursor: 'pointer',
        },
    },
};
